import React, { useContext } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { ThemeContext } from 'providers/ThemeProvider';
import { Container, Button } from 'components/common';
import dev from 'assets/illustrations/skills.svg';
import { Wrapper, SkillsWrapper, Details, Thumbnail } from './styles';

export const Skills = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper id="about">
      <SkillsWrapper as={Container}>
        <Thumbnail>
          <img src={dev} alt="I’m Akshay and I’m a Mobile appliction & Full stack web developer" />
        </Thumbnail>
        <Details theme={theme}>
          <h1>More about me</h1>
          <p>
           I’m a Full stack web developer & Mobile application developer. I enjoy learning about new technologies. I am also a tech enthusiast. <br/>
          </p>
          <h6>My Skills:</h6>
          <ul>
            <li>Mobile : Android (Java, Kotlin), Flutter , React Native</li>
            <li>Web: MERN, ReactJS, NodeJS,Redux, PHP, Python Flask </li>
            <li>Database: MySQL, Firebase, MongoDB</li>
            <li>Adobe XD</li>
          </ul>
          <Button as={AnchorLink} href="#contact">
            Contact me
          </Button>
        </Details>
      </SkillsWrapper>
    </Wrapper>
  );
};
